import * as React from 'react';
import EditDesignPreferencePageView from '../layouts/EditDesignPreferences';
// import { DesignPref } from 'src/reducers/userProfile';
import { DesignPreferencesData, CustDPrefData } from 'src/reducers/editDesignPreference';

export interface EditDesignPreferencePageViewProps {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;
  designPreferenceData: Array<DesignPreferencesData>;
  custDPrefData: Array<CustDPrefData>;
  updatePreferences: (parentcode: string, listtype: string, value: string, selectedValueDesc: string, fieldvalue: string) => void;

  onSubmitDesign: () => void;
  onReset: () => void;
}

class EditDesignPreferencePage extends React.Component<EditDesignPreferencePageViewProps> {
  render() {
    return (
      <div>
        <EditDesignPreferencePageView
          designPreferenceData={this.props.designPreferenceData}
          custDPrefData={this.props.custDPrefData}
          updatePreferences={this.props.updatePreferences}
          onSubmitDesign={this.props.onSubmitDesign}
          onReset={this.props.onReset}
        />
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    this.props.onComponentWillMount();
  }
}

export default EditDesignPreferencePage;



// WEBPACK FOOTER //
// ./src/components/editdesignPreferences/EditDesignPreferencePage.tsx